export class SEOModelData {
    Title: string = '';
    metaKeyword: string = '';
    metaDescription: string = '';
}
